<template>
  <span class="text">
    {{ text }}
  </span>
</template>
<style>
</style>
<script>
export default {
  name: 'TestElement',
  props: {
    text: {
      type: String,
      default: 'x'
    }
  }
};
</script>



// WEBPACK FOOTER //
// TestElement.vue?0938ec1e